<template>
  <div>
    <br />
    <app-history @clicked="$router.push('/ezam-history')" title="اعزام ها" />
    <app-history @clicked="$router.push('/jazb')" title="درخواست جذب" />
        <app-history @clicked="$router.push('/ezamrequest')" title="درخواست تبلیغ" />

  </div>
</template>

<script>
import HistoryButton from "@/components/HistoryButton";
export default {
  components: {
    appHistory: HistoryButton,
  },
};
</script>
<style scoped>
.register {
  margin: 20px 20px 0 20px !important;
}
</style>
